export const isAbortSignalError = (error: unknown) =>
  error instanceof DOMException && error.name === 'AbortError'
